const FacebookIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-facebook 1'>
      <path
        id='Vector'
        d='M12.3334 2.5C9.81382 2.5 7.39746 3.50089 5.61586 5.28249C3.83426 7.06408 2.83337 9.48044 2.83337 12C2.83337 14.5196 3.83426 16.9359 5.61586 18.7175C7.39746 20.4991 9.81382 21.5 12.3334 21.5C14.8529 21.5 17.2693 20.4991 19.0509 18.7175C20.8325 16.9359 21.8334 14.5196 21.8334 12C21.8334 9.48044 20.8325 7.06408 19.0509 5.28249C17.2693 3.50089 14.8529 2.5 12.3334 2.5Z'
        fill='#FAFAFA'
      />
      <path
        id='Vector_2'
        d='M13.6194 14.5179H16.0779L16.4639 12.0204H13.6189V10.6554C13.6189 9.61789 13.9579 8.69789 14.9284 8.69789H16.4879V6.51839C16.2139 6.48139 15.6344 6.40039 14.5394 6.40039C12.2529 6.40039 10.9124 7.60789 10.9124 10.3589V12.0204H8.56189V14.5179H10.9124V21.3824C11.3779 21.4524 11.8494 21.4999 12.3334 21.4999C12.7709 21.4999 13.1979 21.4599 13.6194 21.4029V14.5179Z'
        fill='#0E2C37'
      />
    </g>
  </svg>
)

export default FacebookIcon
